module.exports = __webpack_public_path__ + "img/avatar.ba6d3e2a.png";